export const QUERY_FILTER_ICONS = [
  {
    icon: 'rule',
    tooltip: 'Filter'
  },
  {
    icon: 'auto_awesome',
    tooltip: 'Magic'
  },
  {
    icon: 'whatshot',
    tooltip: 'TORCH'
  },
  {
    icon: 'flight',
    tooltip: 'Airplane',
  },
  {
    icon: 'attach_money',
    tooltip: 'Cost'
  }
];
